import React, { useState, useEffect, useRef } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import '/node_modules/react-grid-layout/css/styles.css';
import '/node_modules/react-resizable/css/styles.css';
import loadJsonData from '../Utils/jsonGet';
import MFXLocalStorage from 'Helpers/MFXLocalStorage';
import URLS from '../Utils/URLs.API';
import loadJsonPut from '../Utils/jsonPut';
import Filterbutton from '../Elements/Filterbutton';
import Addbutton from '../Elements/Addbutton';
import ModalPopup from '../Common/ModalPopup';
import { AddViewProvider } from './AddView';
import { getPropertiesPerType } from 'Helpers/getPropertiesPerType';
import FullTextSearch from '../Elements/FullTextSearch';
import Filter from '../Elements/Filter';
import SessionStorage from '../../../Helpers/MFXSessionStorage';
import LocalStorage from 'Helpers/MFXLocalStorage';
import { useSearchParams } from 'react-router-dom';
import { eventBus } from '../Utils/eventBus';
import SavedModal from '../Elements/SavedModal';
import beerTaost from '../../../Styles/gif/beerToast.gif';
import Loading from '../Elements/Loading';
import GenericDetailView from './GenericDetailView';
import { useSwipeable } from 'react-swipeable';
import ReactSelect from '../Elements/ReactSelect';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

/**
 * Renderes a List
 * @param {any} props Properties given by the caller
 * @returns {JSX.Element} Rendered Element.
 */
function PreSalesView(props: any): JSX.Element {
    const [compactType, setcompactType] = useState('vertical' as any);
    const [searchParams] = useSearchParams();
    const [mounted, setmounted] = useState(false);
    const [showGif, setShowGif] = useState(false);
    const [layouts, setLayouts] = useState([] as any);
    const [headers, setHeaders] = useState([] as any);
    const [saveMessage, setSaveMessage] = useState(null as any);
    const [selectedProject, setSelectedProject] = useState(searchParams.get('project'));
    const [states, setStates] = useState({
        dataLoaded: false,
        disableMode: true,
        addMode: false,
        detailView: false,
    });

    //#region Filters
    const filterName = 'filter_' + props.ViewName + '_' + props.LayoutName;
    const specialFilterName = 'specialFilter_' + props.ViewName + '_' + props.LayoutName;
    const searchName = 'searchText_' + props.ViewName + '_' + props.LayoutName;

    const [searchTextParam, setSearchTextParam] = useState(useSearchParams()[0].get(searchName) ?? '');
    const [filterParam, setFilterParam] = useState(useSearchParams()[0].get(filterName));
    const [urlParamsObject, setUrlParamsObject] = useState(null as any);
    const [defaultFiltersLoaded, setDefaultFiltersLoaded] = useState(false);
    const [filterActive, setFilterActive] = useState(false);
    const [urlsLoaded, setUrlsLoaded] = useState(false);

    const curProperties = getPropertiesPerType(props.ViewName);
    const [specialFilterFromUrl, setSpecialFilterFromUrl] = useState(useSearchParams()[0].get(specialFilterName)?.replace(' AND ', '&'));
    const [specialFilter, setSpecialFilter] = useState(
        SessionStorage.getData(LocalStorage?.getTabData()?.primaryType + '_' + specialFilterName)
            ? SessionStorage.getData(LocalStorage?.getTabData()?.primaryType + '_' + specialFilterName)
            : specialFilterFromUrl
              ? specialFilterFromUrl
              : props.designer?.Settings?.ExtraFilter
                ? props.designer?.Settings?.ExtraFilter[0] === '&'
                    ? props.designer?.Settings?.ExtraFilter.substring(1)
                    : props.designer?.Settings?.ExtraFilter
                : curProperties?.extraFilter
                  ? curProperties?.extraFilter
                  : '',
    );
    const [profCritFilter, setProfCritFilter] = useState([]);
    const [eventCounter, setEventCounter] = useState(0);

    const [sortingColumn, setSortingColumn] = useState(props.designer?.Settings?.SortColumn ? props.designer?.Settings?.SortColumn + (props.designer?.Settings?.SortDescending ? ' DESC' : '') : '');

    const [selectedFilter, setSelectedFilter] = useState(-1);
    const [key, setKey] = useState(0);
    const handlers = useSwipeable({
        onSwipedLeft: () => {
            setSelectedColumn(prev => Math.min(prev + 1, headers.length - 1));
        },
        onSwipedRight: () => {
            setSelectedColumn(prev => Math.max(prev - 1, 0));
        },
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    } as any);
    useEffect(() => {
        if (urlsLoaded) {
            var paramString = '';
            Object.entries(urlParamsObject).forEach((obj: any) => {
                if (!obj[1]) return;
                if (paramString) paramString += '&';

                paramString += obj[0] + '=' + obj[1].toString().replaceAll('&', ' AND ');
            });

            var comb = combineUrlParams(paramString, window.location.href.split('?')[1]);
            var newurl = window.location.href.split('?')[0] + (comb ? '?' + comb : '');
            if (window.location.href !== newurl) window.history.replaceState({ path: newurl }, '', encodeURI(newurl));
        }
    }, [urlParamsObject]);

    function combineUrlParams(param1, param2) {
        if (!param2) return param1;
        var param1A;
        var param2A;

        try {
            param1A = decodeURIComponent(param1)?.split('&');
        } catch (ex) {
            param1A = param1?.split('&');
        }
        try {
            param2A = decodeURIComponent(param2)?.split('&');
        } catch (ex) {
            param2A = param2?.split('&');
        }
        param2A?.forEach(p => {
            var name = p.split('=')[0];
            var exists = param1A?.find(p1 => p1.split('=')[0] === name);
            if (!exists && name !== filterName && name !== searchName) {
                param1 += (param1 ? '&' : '') + p;
            }
        });
        return param1;
    }

    useEffect(() => {
        if (defaultFiltersLoaded) {
            var res = filterParam as any;
            if (res) {
                props?.designer?.Filter?.Data?.filter((f: any) => f.ReadOnly && !f.ProfCrit)?.forEach(d => {
                    var index = res.indexOf(d.Key.replace('-', '.') + ' ');
                    if (index === -1) {
                        window.location.href = window.location.href.split('?')[0];
                    } else {
                        var start = res.indexOf('"', index) + 1;
                        var end = res.indexOf('"', start);
                        if (d.DefaultValue && typeof d.DefaultValue === 'string' && d.DefaultValue?.toLowerCase().split('.')[0] === 'userdata') {
                            d.DefaultValue = LocalStorage?.getData('UserData') ? LocalStorage?.getData('UserData')[d.DefaultValue.split('.')[1]] : d.DefaultValue;
                            if (isNaN(d.DefaultValue)) d.DefaultValue = 999;
                        }
                        if ((d.Type === 'date' || d.Type === 'datetime-local') && d.DefaultValue === 'NOW') {
                            const date = new Date();
                            date.setDate(date.getDate() + (+d.DefaultValueOffset || 0));
                            d.DefaultValue = date.toISOString().substring(0, 10);
                        }
                        var sub = res.substring(0, start) + (d.Operator === 'LIKE' ? '%' + d.DefaultValue + '%' : d.DefaultValue) + res.substring(end);
                        res = sub;
                        index = res.indexOf(d.Key + ' ');
                    }
                });
                setUrlParams(filterName, res);
                if (specialFilter) {
                    setUrlParams(specialFilterName, specialFilter);
                }
                if (specialFilter) {
                    setUrlParams(specialFilterName, specialFilter);
                }
            }
            setUrlsLoaded(true);
        }
    }, [defaultFiltersLoaded]);

    function setSpecializedFilter(newFilter) {
        console.log(newFilter);

        const [newKey, newValue] = (newFilter || '').split('=');

        setSpecialFilter(prev => {
            const prevFilters = (prev || '')
                .split('&')
                .map(f => f.trim())
                .filter(Boolean);

            const existingFilters = prevFilters.filter(f => {
                const [k] = f.split('=');
                return k !== newKey;
            });

            if (newKey && newValue && newValue.trim() !== '' && newValue.trim().toLowerCase() !== 'null') {
                existingFilters.push(`${newKey}=${newValue}`);
            }

            const res = existingFilters.join('&');
            console.log(res);
            setUrlParams(specialFilterName, res);
            return res;
        });
    }

    function addParamToUrl(index) {
        var params = window.location.href.split('?')[1];
        if (params) {
            var newParams = params.split('&').filter(p => !p.includes('project'));
            newParams.push('project=' + index);
            params = newParams.join('&');
        } else {
            params = 'project=' + index;
        }
        var newurl = window.location.href.split('?')[0] + (params ? '?' + params : '');
        if (window.location.href !== newurl) window.history.replaceState({ path: newurl }, '', encodeURI(newurl));
    }
    //#endregion Filters

    function selectItem(item) {
        var params = window.location.href.split('?')[1];
        setSelectedProject(item?.ProjectNumber);
        if (params) {
            var newParams = params.split('&').filter(p => !p.includes('project') && !p.includes('customer'));

            newParams.push('project=' + item?.ProjectNumber);
            newParams.push('customer=' + item?.ProjectCustomer?.CustomerNumber);
            params = newParams.join('&');
        } else {
            params = 'project=' + item?.ProjectNumber + '&customer=' + item?.ProjectCustomer?.CustomerNumber;
        }
        var newurl = window.location.href.split('?')[0] + (params ? '?' + params : '');
        if (window.location.href !== newurl) window.history.replaceState({ path: newurl }, '', encodeURI(newurl));
    }

    useEffect(() => {
        if (eventCounter > 0) {
            loadData();
        }
    }, [eventCounter]);

    useEffect(() => {
        registerEventBus();
    }, []);

    function registerEventBus() {
        const handleMessage = msg => {
            console.log(profCritFilter);
            setEventCounter(prev => prev + 1);
        };

        eventBus.on('message', handleMessage);

        // Clean up when the component unmounts
        return () => {
            eventBus.off('message', handleMessage);
        };
    }

    const sendMessage = () => {
        eventBus.emit('preSales', 'Update');
    };

    useEffect(() => {
        if (defaultFiltersLoaded) {
            setmounted(true);
            loadData();
        }
    }, [defaultFiltersLoaded, searchTextParam, filterParam, specialFilter, profCritFilter]);

    //#region mobile handling
    const [selectedColumn, setSelectedColumn] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= window.mobileBreakPoint);
    const filteredLayouts = isMobile ? layouts.filter(l => l.data?.ProjectStatusInx === headers[selectedColumn]?.Inx) : layouts;
    const extendedLayouts = filteredLayouts.reduce((acc, itm) => {
        acc.push(itm); // main item
        if (selectedProject === itm.data?.ProjectNumber) {
            acc.push({
                i: `${itm.i}-details`,
                x: 0,
                y: itm.y + itm.h,
                w: 1,
                h: 5,
                static: true,
                isResizable: false,
                data: itm.data, // pass data for details
                isDetail: true,
            });
        }
        return acc;
    }, []);

    //#endregion mobile handling

    function loadData() {
        var filterentries = '';
        let allFilterEntries = '';
        allFilterEntries += filterParam ? (allFilterEntries ? ' AND ' + filterParam : filterParam) : '';
        allFilterEntries += filterentries ? (allFilterEntries ? ' AND ' + filterentries : filterentries) : '';
        loadJsonData(
            '/' +
                MFXLocalStorage?.getConnectionKey() +
                URLS.GetPreSales +
                '?' +
                (searchTextParam ? 'Filter.FilterText=' + searchTextParam : '') +
                (allFilterEntries ? (searchTextParam ? '&FilterEntries=' : 'FilterEntries=') + allFilterEntries : '') +
                (specialFilter ? '&' + specialFilter : '') +
                (sortingColumn ? '&Paging.SortingColumn=' + sortingColumn : '') +
                (profCritFilter && profCritFilter.length > 0 ? '&ProfFilterEntries=' + JSON.stringify(profCritFilter) : ''),
        ).then((data: any) => {
            if (data?.Meta?.Success && data?.Data?.StatusSystem) {
                var headers = [] as any;
                var projects = [] as any;
                data?.Data?.StatusSystem[0]?.Status?.forEach(element => {
                    headers.push({ Description: element.Description, PercentValue: element.PercentValue, SortCode: element.SortCode, StatusSum: element.StatusSum, Inx: element.Inx, StatusColor: element.StatusColor, StatusCurrency: element.StatusCurrency });
                });
                headers.sort((a, b) => (a.SortCode < b.SortCode ? -1 : 1));
                data?.Data?.StatusSystem[0]?.Status?.forEach(element => {
                    element?.Projects?.forEach((project, inx) => {
                        var layout = { i: project.ProjectNumber, x: headers?.findIndex(h => h.Inx === element.Inx), y: inx, w: 1, h: 1, isResizable: false, data: { ...project } };
                        projects.push(layout);
                    });
                });
                setLayouts(projects);
                setHeaders(headers);
            } else {
                setSaveMessage({ message: data?.Meta?.ErrorMessages?.[0]?.Message, success: false });
                setLayouts([]);
                setHeaders([]);
                logger.warning(data.Meta.Message);
            }
        });
    }

    const onDragStop = (layout, oldItem, newItem) => {
        if (newItem.x === oldItem.x) return;
        var data = layouts?.find(i => {
            // eslint-disable-next-line eqeqeq
            return i.i == newItem.i;
        })?.data;
        if (data) {
            data.ProjectStatusInx = headers[newItem?.x]?.Inx;
            loadJsonPut('/' + MFXLocalStorage?.getConnectionKey() + URLS.UpdateProject, { UpdateData: data }).then((d: any) => {
                if (d?.Meta?.Success) {
                    if (
                        headers[newItem?.x]?.Inx ===
                        headers.reduce((maxItem, currentItem) => {
                            return currentItem.SortCode > (maxItem?.SortCode ?? -Infinity) ? currentItem : maxItem;
                        }, null).Inx
                    ) {
                        showGifTemporarily();
                    }
                    sendMessage();
                    loadData();
                    //MFXLocalStorage.setLocalData('ProjectChanges')
                } else {
                    if (d) {
                        setSaveMessage({ message: d?.Meta?.ErrorMessages?.[0]?.Message, success: false });
                        logger.warning(d?.Meta?.Message);
                    }
                    setKey(prev => prev + 1);
                    loadData();
                }
            });
        }
    };
    function showGifTemporarily() {
        setShowGif(true);
        setTimeout(() => {
            setShowGif(false);
        }, 2200);
    }

    const element = document.getElementById('pre-sales-view');
    const headerCount = headers?.length || 0;
    const marginLeft = 20; // margin-left in pixels
    const totalMargin = marginLeft * (headerCount - 1); // total margin for all columns except the last one
    const availableWidth = 100 - (totalMargin / (element?.offsetWidth ?? 1)) * 100; // subtract margin percentage from total width

    const width = `${availableWidth / headerCount}%`;

    function setUrlParams(type: any, query: any) {
        switch (type) {
            case filterName:
                setFilterParam(query);
                SessionStorage.createSession(LocalStorage?.getTabData()?.primaryType + '_' + type, query);
                break;
            case specialFilterName:
                console.log(query);
                SessionStorage.createSession(LocalStorage?.getTabData()?.primaryType + '_' + type, query);
                break;
            case searchName:
                setSearchTextParam(query);
                break;
        }
        setUrlParamsObject(prev => {
            return { ...prev, [type]: query };
        });
    }
    function truncateString(str, length) {
        return str?.length > length ? str?.slice(0, length) + '...' : str;
    }

    function handleDrag(layout, oldItem, newItem, placeholder, e, element) {
        const container = document.querySelector('.layout');
        const rect = container?.getBoundingClientRect();

        if (rect && (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom)) {
            e.preventDefault();
            return false;
        }
    }
    return (
        <>
            <div className="pre-sales-view" id="pre-sales-view">
                <div style={{ minWidth: !isMobile ? headers?.length * 250 + 'px' : '100%' }}>
                    <b></b>
                    <div className="mfx-action-buttons">
                        {props.designer?.PreMadeFilters?.length > 0 && (
                            <ReactSelect
                                id="select-premade-filter"
                                classNamePrefix={'mfx-designer-select-layout'}
                                disableCreate={true}
                                onChange={(newValue: any) => {
                                    setSelectedFilter(newValue.value);
                                }}
                                options={[
                                    { label: 'Default', value: -1 },
                                    ...(props.designer.PreMadeFilters?.map((f: any, inx: any) => {
                                        return { label: f?.Name, value: inx };
                                    }) || []),
                                ]}
                                value={{ label: props.designer?.PreMadeFilters?.[+selectedFilter]?.Name ?? 'Default', value: +selectedFilter }}></ReactSelect>
                        )}
                        {/*props.designer?.PreMadeFilters?.length > 0 && (
                            <select
                                id="select-premade-filter"
                                onChange={(newValue: any) => {
                                    setSelectedFilter(newValue.value);
                                }}
                                value={+selectedFilter }>
                                    <option value={-1}>Default</option>
                                    {props.designer.PreMadeFilters?.map((f: any, inx: any) => {
                                        return <option value={inx}>{f?.Name}</option>;
                                    })}
                                </select>
                        )*/}
                        <FullTextSearch value={searchTextParam} loadSearchData={val => setUrlParams(searchName, val)}></FullTextSearch>
                        {<Filterbutton setFilterMode={() => setFilterActive(prev => !prev)} filterMode={filterActive} />}

                        {curProperties?.actions.add && (
                            <Addbutton
                                disableChangeHandler={(save: boolean) => {
                                    setStates({ ...states, addMode: !states.addMode });
                                }}
                                disableMode={states.addMode}
                            />
                        )}
                    </div>
                    <Filter
                        specialFilter={specialFilter}
                        selectedFilter={selectedFilter}
                        preMadeFilters={props.designer.PreMadeFilters}
                        setSpecialFilter={setSpecializedFilter}
                        setProfCritFilter={array => setProfCritFilter(array)}
                        filterQuery={filterParam}
                        setUrlParams={setUrlParams}
                        filterName={filterName}
                        setDefaultFiltersLoaded={setDefaultFiltersLoaded}
                        filters={props.designer.Filter}
                        filterActive={filterActive}
                        profCritFilters={profCritFilter}
                    />
                    {headers?.length <= 0 && <Loading />}
                    {headers?.length > 0 && !isMobile && (
                        <div style={{ width: '100%', minWidth: headers?.length * 230 + 'px', marginBottom: '80px', marginTop: '10px' }}>
                            <div className="headers">
                                {headers?.map((header, i) => (
                                    <div
                                        className={'header pointer' + (i === 0 ? '-first' : i === headers?.length - 1 ? '-last' : '')}
                                        style={{ marginRight: i === headers?.length - 1 ? (props?.designer?.Settings?.ShowOverflow ? '32px' : '20px') : '0px', width: width, backgroundColor: header?.StatusColor, '--arrow-color': header?.StatusColor ?? 'var(--pageBg)' } as any}
                                        key={i}>
                                        <div className="block-header">{header.Description}</div>
                                        <div id="presales-sum">{header.PercentValue + '% ' + (header.StatusCurrency ?? '€') + ' ' + new Intl.NumberFormat('en-DE', { maximumFractionDigits: 2 }).format(header.StatusSum ?? 0)}</div>
                                        <span className="circle" id={header.Description + '-length'}>
                                            {layouts?.filter((l: any) => l?.data?.ProjectStatusInx === header?.Inx).length}
                                        </span>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    scrollbarGutter: props?.designer?.Settings?.ShowOverflow ? 'stable' : 'unset',
                                    overflow: props?.designer?.Settings?.ShowOverflow ? 'auto' : 'unset',
                                    maxHeight: props?.designer?.Settings?.ShowOverflow ? (props?.designer?.Settings?.MaxHeight ? props?.designer?.Settings?.MaxHeight + 'px' : '700px') : 'unset',
                                    paddingRight: '10px',
                                }}>
                                <ResponsiveReactGridLayout
                                    {...props}
                                    rowHeight={100}
                                    breakpoints={{ lg: 900 }}
                                    key={key}
                                    cols={{ lg: headers?.length || 1 }}
                                    layouts={layouts}
                                    measureBeforeMount={true}
                                    useCSSTransforms={mounted}
                                    isBounded={true} // if you want to limit the item drag to the container size
                                    compactType={compactType}
                                    onDragStop={onDragStop}
                                    preventCollision={!compactType}
                                    containerPadding={[20, 10]}
                                    margin={[19, 10]}>
                                    {layouts.map(itm => (
                                        <div
                                            key={itm.i}
                                            data-grid={itm}
                                            className="block"
                                            onClick={() => selectItem(itm.data)}
                                            style={{
                                                backgroundColor: itm?.data?.ProjectCategoryColor,
                                                border: itm.data?.ProjectNumber?.toString() === selectedProject?.toString() ? '3px solid var(--highlightColor)' : '0px solid var(--highlightColor)',
                                            }}>
                                            <div className="block-header">{truncateString(itm.data?.ProjectName, 22)}</div>
                                            <div>{truncateString(itm.data?.ItemDescription, 30)}</div>
                                            <div>{truncateString(itm.data?.PersonInChargeName, 30)}</div>
                                            <div>
                                                {itm.data?.Currency} {new Intl.NumberFormat('en-DE', { maximumFractionDigits: 2 }).format(itm.data?.ForecastedSales ?? 0)}
                                            </div>
                                        </div>
                                    ))}
                                </ResponsiveReactGridLayout>
                            </div>
                        </div>
                    )}
                    {headers?.length > 0 && isMobile && (
                        <div {...handlers}>
                            <div className="mobile-presales-nav">
                                {/* Left arrow button 
                                <button onClick={() => setSelectedColumn(prev => Math.max(prev - 1, 0))} disabled={selectedColumn === 0} aria-label="Previous column">
                                    ‹
                                </button>*/}
                                <select
                                    value={selectedColumn}
                                    onChange={e => setSelectedColumn(Number(e.target.value))}
                                    style={{
                                        backgroundColor: headers[selectedColumn]?.StatusColor ?? 'var(--bgColor)',
                                        width: '100%',
                                    }}>
                                    {headers.map((h, i) => (
                                        <option key={i} value={i} style={{ backgroundColor: h.StatusColor ?? 'var(--bgColor)' }}>
                                            {h.Description}
                                        </option>
                                    ))}
                                </select>
                                <div
                                    className="presales-info"
                                    style={{
                                        backgroundColor: headers[selectedColumn]?.StatusColor ?? 'var(--bgColor)',
                                    }}>
                                    <span id={headers[selectedColumn].Description + '-length'}>({layouts?.filter((l: any) => l?.data?.ProjectStatusInx === headers[selectedColumn]?.Inx).length})</span>
                                    <div id="presales-sum"> {headers[selectedColumn]?.PercentValue + '% ' + (headers[selectedColumn]?.StatusCurrency ?? '€') + ' ' + new Intl.NumberFormat('en-DE', { maximumFractionDigits: 2 }).format(headers[selectedColumn]?.StatusSum ?? 0)}</div>
                                </div>
                                {/* Right arrow button 
                                <button onClick={() => setSelectedColumn(prev => Math.min(prev + 1, headers.length - 1))} disabled={selectedColumn === headers.length - 1} aria-label="Next column">
                                    ›
                                </button>*/}
                            </div>

                            <ResponsiveReactGridLayout {...props} autoSize={true} rowHeight={100} breakpoints={{ lg: 900 }} cols={isMobile ? { lg: 1, sm: 1, xs: 1 } : { lg: headers?.length || 1 }} margin={[0, 0]} isDraggable={false} isResizable={false} layouts={{ lg: extendedLayouts }}>
                                {extendedLayouts.map(itm => {
                                    if (itm.isDetail) {
                                        return (
                                            <div key={itm.i} data-grid={itm} className="detail-panel-mobile">
                                                <div className="presales-detail-wrapper-mobile">
                                                    <GenericDetailView containerData={{ Headline: 'Details' }} ViewName="ProjectDetailView" LayoutName="default-mobile" noActionButtons={true}></GenericDetailView>
                                                </div>
                                            </div>
                                        );
                                    }

                                    // Main item
                                    return (
                                        <div
                                            key={itm.i}
                                            data-grid={itm}
                                            className="block-mobile"
                                            onClick={() => selectItem(itm.data)}
                                            style={{
                                                backgroundColor: itm?.data?.ProjectCategoryColor,
                                                border: itm.data?.ProjectNumber?.toString() === selectedProject?.toString() ? '3px solid var(--highlightColor)' : '0px solid var(--highlightColor)',
                                            }}>
                                            <div className="block-header-mobile">{itm.data?.ProjectName}</div>
                                            <div>{itm.data?.ItemDescription}</div>
                                            <div>{itm.data?.PersonInChargeName}</div>
                                            <div>
                                                {itm.data?.Currency} {new Intl.NumberFormat('en-DE', { maximumFractionDigits: 2 }).format(itm.data?.ForecastedSales ?? 0)}
                                            </div>
                                        </div>
                                    );
                                })}
                            </ResponsiveReactGridLayout>
                        </div>
                    )}
                </div>
            </div>
            {showGif && (
                <div className="overlay">
                    <img src={beerTaost} alt="Loading..." />
                </div>
            )}
            {states.addMode && (
                <ModalPopup modalClass="mfx-add-modal">
                    <AddViewProvider changeView={() => setStates({ ...states, addMode: false })} viewName={curProperties?.addView} fixCustomer={MFXLocalStorage.getCurrentPath().indexOf('CUSTOMER') > 0 ? true : false} viewSettings={curProperties}>
                        <div className="mfx-action-buttons">
                            <Addbutton
                                disableChangeHandler={() => {
                                    setStates({ ...states, addMode: !states.addMode });
                                }}
                                disableMode={states.addMode}
                                save={false}
                            />
                        </div>
                    </AddViewProvider>
                </ModalPopup>
            )}
            {saveMessage && (
                <SavedModal
                    saveMessage={saveMessage}
                    closeIcon={true}
                    handleClose={() => {
                        setSaveMessage(null);
                    }}
                />
            )}
        </>
    );
}

export default PreSalesView;
